<template>
  <div>
    <v-container class="mb-4">
      <p>
        Você pode selecionar <b>até 15</b> transportadoras de sua preferência.
        Sua cotação também ficará disponível para outras transportadoras da rede.
      </p>
      <px-lista-selecao-transportador v-model="cotacao.transportadoras"
                                      :max-select="15"
                                      :municipio-coleta="cotacao.municipioColeta"
                                      @reset="resetTransportador"/>
    </v-container>

    <v-btn color="primary"
           class="mr-2"
           :loading="loadingForm"
           :disabled="!cotacao.transportadoras || !cotacao.transportadoras.length"
           @click="$emit('next')">
      Enviar
    </v-btn>
    <v-btn text link @click="$emit('previous')">Voltar</v-btn>
  </div>
</template>

<script>
import PxListaSelecaoTransportador from
  '../../lista-selecao-transportadora/PxListaSelecaoTransportador.vue';

export default {
  props: {
    cotacao: Object,
    loadingForm: Boolean,
  },
  methods: {
    resetTransportador() {
      this.cotacao.transportadoras = [];
    },
  },
  components: {
    PxListaSelecaoTransportador,
  },
};
</script>
